<template>
  <input
    ref="refInput"
    pattern="[0-9]*"
    inputmode="numeric"

    @input="onInput"
    @blur="onInputBlur"
  >
</template>

<script>

// const allowedCtrlKeys = [
//   8, // backspace
//   9, // tab
//   37, // arrow left
//   39, // arrow right
// ];

export default {
  name: 'MpnInputNumberOnly',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      val: this.value,
      pass: false,
    };
  },
  computed: {

  },
  watch: {
    value(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.val = newVal;
      this.updateElement();
    },
  },
  mounted() {
    if (this.val) {
      this.updateElement();
    }
  },
  methods: {
    onInput(evt) {
      // console.log('input', evt);
      if (evt.data >= '0' && evt.data <= '9') {
        // pass
        this.val = this.$refs.refInput.value;
      } else {
        this.val = this.$refs.refInput.value.replace(/[^\d]/, '');
        this.updateElement();
      }
      this.onChange();
    },
    onInputBlur() {
      this.$emit('blur');
    },
    onChange() {
      // console.log('onchange', this.$refs.refInput.value, this.val);
      this.$emit('input', this.val);
      this.$emit('change', this.val);
    },
    updateElement() {
      this.$refs.refInput.value = this.val;
    },
  },

};
</script>

<style scoped>
input {
  ime-mode: disabled; /* for IE */
}
</style>



// WEBPACK FOOTER //
// src/plugins/mpn-base-components/MpnInputNumberOnly.vue